import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center"
}
const _hoisted_2 = { class: "relative bg-white rounded-2xl max-w-3xl shadow-lg w-11/12 flex flex-col max-h-[90vh]" }
const _hoisted_3 = { class: "px-6 py-4 border-b border-gray-200" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "text-sm text-gray-500" }
const _hoisted_6 = { class: "flex items-center gap-4" }
const _hoisted_7 = { class: "text-sm font-medium text-gray-500" }

import { ref, computed } from 'vue'
import { TalentPoolForm, FormNavigation } from './talentPoolForm'
import { useTalentPoolsStore } from '@/stores/talentPoolsStore'
import { CircleX } from 'lucide-vue-next'
import { useProjectsStore } from '@/stores/projectsStore'
import type { TalentPoolFormExposed } from '@/types/talentPoolForm'


export default /*@__PURE__*/_defineComponent({
  __name: 'EditModal',
  setup(__props, { expose: __expose }) {

__expose({ show, close })

const open = ref(false)
const formRef = ref<TalentPoolFormExposed | null>(null)
const talentPoolsStore = useTalentPoolsStore()
const projectsStore = useProjectsStore()

const wizardMeta = computed(() => {
  const form = formRef.value
  if (!form) return { step: 1, total: 1, label: '' }
  const step = (form.currentStepIndex ?? 0) + 1
  const total = form.steps.length
  const label = form.currentStep.label
  return { step, total, label }
})

function show() {
  open.value = true
}

function close() {
  open.value = false
}

const handleUpdate = async () => {
  if (!formRef.value) return
  const { form, newProject, projectMode, selectedProject, editor } = formRef.value as any

  let projectId: number | null = null

  if (form.type === 'project') {
    if (projectMode === 'existing' && selectedProject) {
      projectId = selectedProject.id
    } else if (projectMode === 'new') {
      const project = await projectsStore.createProject(newProject)
      if (!project) {
        console.error('Project creation failed.')
        return
      }
      projectId = project.id
    }
  }

  const updatedPool = {
    type: form.type,
    location: form.location.address.trim(),
    location_lat: form.location.lat,
    location_lng: form.location.lng,
    title: form.title.trim(),
    description: editor.getJSON(),
    workType: form.workType,
    rate: form.salary,
    rateType: form.salaryType,
    hiring_timeline: form.hiringTimeline,
    timeline: form.hiringTimeline === 'specific_date' ? form.timeline : null,
    requirements: form.requirements,
    qualifications: form.qualifications,
    projectId,
  }

  // await talentPoolsStore.updateTalentPool(talentPoolsStore.activePool.id, updatedPool)
  close()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (open.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "absolute inset-0 bg-black/50",
                onClick: close
              }),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-xl font-semibold text-gray-900 leading-tight" }, "Edit Talent Pool", -1)),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(wizardMeta.value.label), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, " Step " + _toDisplayString(wizardMeta.value.step) + " of " + _toDisplayString(wizardMeta.value.total), 1),
                      _createVNode(_unref(CircleX), {
                        class: "h-6 w-6 text-gray-500 cursor-pointer",
                        onClick: close
                      })
                    ])
                  ])
                ]),
                _createVNode(_unref(TalentPoolForm), {
                  ref_key: "formRef",
                  ref: formRef,
                  mode: "edit",
                  "initial-data": _unref(talentPoolsStore).activePool
                }, null, 8, ["initial-data"]),
                (formRef.value)
                  ? (_openBlock(), _createBlock(_unref(FormNavigation), {
                      key: 0,
                      "can-proceed": formRef.value.canProceedToNextStep,
                      "is-first-step": formRef.value.currentStepIndex === 0,
                      "is-last-step": formRef.value.currentStepIndex === formRef.value.steps.length - 1,
                      "submit-label": 'Update Talent Pool',
                      onPrev: _cache[0] || (_cache[0] = ($event: any) => (formRef.value.decreaseStep())),
                      onNext: _cache[1] || (_cache[1] = ($event: any) => (formRef.value.increaseStep())),
                      onSubmit: handleUpdate,
                      onCancel: close
                    }, null, 8, ["can-proceed", "is-first-step", "is-last-step"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})